import { j as e } from "../../utils-BdNIfrGQ.js";
import { useCallback as x } from "react";
import { a as g } from "../../Button-CzIiGCVn.js";
import "../../Div-spVpsZsH.js";
import "../../Div.skeleton-DLnqOZrU.js";
import { F as h } from "../../Flex-BA9xHq_p.js";
import "../../Grid-DJGISvmf.js";
import { u as j } from "../../toast-DrFMmSLk.js";
import "react-dom";
import { S as y } from "../../share-splatWmh.js";
const S = /* @__PURE__ */ e.jsx(y, { role: "presentation", size: 16, "aria-hidden": !0 }), I = ({
  copiedLabel: i,
  shareTitle: t,
  shareText: a,
  shareUrl: o,
  label: c,
  icon: m = S,
  size: p = "icon",
  trackingLocation: n,
  variant: d = "outline",
  ...f
}) => {
  const { toast: s } = j(), l = x(async () => {
    if (typeof navigator.share == "function") {
      const r = { url: o };
      a && (r.text = a), t && (r.title = t);
      try {
        await navigator.share(r);
      } catch (u) {
        console.error("Failed to share", {
          shareText: a,
          shareTitle: t,
          shareUrl: o,
          error: u.message
        });
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(o), s({ description: i });
    } catch (r) {
      console.error("Failed to copy to clipboard", { shareUrl: o, error: r.message });
    }
  }, [a, t, o, i, s]);
  return /* @__PURE__ */ e.jsx(
    g,
    {
      "data-dd-action-name": n ? `btn-social_share-${n}` : void 0,
      onClick: l,
      size: p,
      variant: d,
      ...f,
      children: /* @__PURE__ */ e.jsxs(h, { className: "flex-row items-center", gap: "2", children: [
        m,
        c
      ] })
    }
  );
};
export {
  I as default
};
